export default __webpack_public_path__ + "static/media/Conflict of interest Policy 2023.92034e84.pdf";